import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getCalendarColorSchemeByFolderId } from 'owa-calendar-color-resolver';
import { getCalendarFolderId, getCalendarName } from 'owa-publishedcalendar-settings';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';

/**
 * Get calendar data needed for print
 */
export function getPublishedCalendar<TEvent>() {
    const calendarId = getCalendarFolderId();
    const { calendarItems } = getSurfaceStore();

    const calendarsMap: {
        [calendarName: string]: {
            name: string[];
            events: CalendarEvent[];
            calendarColorScheme: ColorScheme[];
        };
    } = {};

    calendarsMap[calendarId] = {
        name: [getCalendarName()],
        events: calendarItems,
        calendarColorScheme: [getCalendarColorSchemeByFolderId(calendarId)],
    };

    return calendarsMap;
}

/**
 * Get charm id for calendar items
 */
export function getCharm(): number {
    return 0; // no charm support for anonymous calendar events
}
